/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
import {
  IconNext,
  IconPre,
  IconSortDown,
  IconSortUp,
  IconSpin,
} from "../../../assets/icon";
import "../../../assets/style/table/statistics.scss";
import { useMemo } from "react";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import {
  getReportTotalPosts,
  getReportViewPosts,
} from "../../../services/slice/statisticsSlice";
import { timeSelectReport } from "../../../utils/ValueSelect";
import SelectValue from "../Selector/SelectValue";

const TableAccessPost = ({ type, config }) => {
  const dispatch = useDispatch();
  const [valueSelectDay, setValueSelectDay] = useState([]);
  const statisticsState = useSelector(statisticsSelector);
  const { dataReportTotalPosts } = statisticsState;
  const [configTbl, setConfigTbl] = useState({
    titlePostList: [],
    timeReport: 1,
    typePosts: type,
    typeField: 1,
    timeCreate: "",
    day: 0,
  });

  useEffect(() => {
    setConfigTbl(config);
  }, [config]);
  useEffect(() => {
    dispatch(getReportTotalPosts(configTbl));
  }, [configTbl, dispatch]);
  const initFacebookSDK = () => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }

    let locale = "vi_VN";
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: window.REACT_APP_FACEBOOK_APP_ID,
        cookie: true, // enable cookies to allow the server to access
        // the session
        xfbml: true, // parse social plugins on this page
        version: "v2.5", // use version 2.1
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = `//connect.facebook.net/${locale}/sdk.js`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };
  useEffect(() => {
    initFacebookSDK();
  }, []);
  useEffect(() => {
    const result = [{ label: "Tất cả", value: 0 }];
    if (config.timeReport === 1) {
      for (let index = 0; index < 7; index++) {
        result.push({
          label: `Ngày ${index + 1}`,
          value: index + 1,
        });
      }
    } else if (config.timeReport === 2) {
      for (let index = 0; index < 14; index++) {
        result.push({
          label: `Ngày ${index + 1}`,
          value: index + 1,
        });
      }
    } else if (config.timeReport === 3) {
      for (let index = 0; index < 21; index++) {
        result.push({
          label: `Ngày ${index + 1}`,
          value: index + 1,
        });
      }
    } else {
      for (let index = 0; index < 28; index++) {
        result.push({
          label: `Ngày ${index + 1}`,
          value: index + 1,
        });
      }
    }
    setValueSelectDay(result);
  }, [config.timeReport]);
  const dataSource = useMemo(() => {
    const result = dataReportTotalPosts?.map((item, index) => {
      return {
        ...item,
        STT: index + 1,
        key: item.id,
        timeCreate: formatDate(item.timeCreate),
      };
    });
    return result;
  }, [dataReportTotalPosts]);
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "centerCell",
      ellipsis: {
        showTitle: false,
      },
      render: (name) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Thời gian tạo" />
        </div>
      ),
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: " collapseText centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Tổng lượt xem" />
        </div>
      ),
      dataIndex: "totalView",
      key: "totalView",
      className: " collapseText centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Tổng lượt hiển thị" />
        </div>
      ),
      dataIndex: "totalDisplay",
      key: "totalDisplay",
      className: " collapseText centerCell",
    },
  ];
  const tableLoading = {
    spinning: false, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  const originalColumns = [...columns]; // Tạo bản sao của mảng cột

  const hiddenColumnKey = "numberNotify"; // key của cột cần loại bỏ

  // Lọc cột cần loại bỏ ra khỏi mảng cột
  const filteredColumns = originalColumns.filter(
    (column) => column.key !== hiddenColumnKey
  );

  return (
    <>
      <div className="chartStatistics tblAccessPost">
        <div className="titleChart">
          <p>
            Tình hình tương tác bài viết trong{" "}
            <span style={{ color: "#F66524" }}>
              {
                timeSelectReport.find(
                  (item) => item.value === config.timeReport
                )?.label
              }
            </span>{" "}
            đầu tiên đăng bài{" "}
          </p>
          <div className="selecter">
            <span>Chọn ngày xem thống kê</span>{" "}
            <SelectValue
              type={"selectGray"}
              optionsValue={valueSelectDay}
              value={configTbl.day}
              width={170}
              handleChange={(value) => {
                setConfigTbl({ ...config, day: value });
              }}
            />
          </div>
        </div>
        <Row style={{ width: "100%" }}>
          <Table
            loading={tableLoading}
            className="wrapperTblStatistics"
            style={{ width: "100%", marginTop: "2.6rem" }}
            // columns={type === 2 ? filteredColumns : columns}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
          />
        </Row>
      </div>
    </>
  );
};

export default TableAccessPost;
